import { render, staticRenderFns } from "./QRCodeScanner.vue?vue&type=template&id=45a508b4&scoped=true"
import script from "./QRCodeScanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRCodeScanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QRCodeScanner.vue?vue&type=style&index=0&id=45a508b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a508b4",
  null
  
)

export default component.exports